<template>
  <div class="video" :style="{backgroundColor: isPlaying ? '#000' : '#ff3c00'}" id="video-nav">
    <div class="header">
      <img
        src="https://summit-img.geekpark.net/mobile/3%E5%88%86%E9%92%9F%E5%B8%A6%E4%BD%A0%E4%BD%93%E9%AA%8C%E3%80%8CIF%E3%80%8D%E6%9E%81%E5%AE%A2%E5%85%AC%E5%9B%AD%E5%88%9B%E6%96%B0%E5%A4%A7%E4%BC%9A.svg" style="width: 100vw">
    </div>
    <div class="video-container">
      <div class="cover" @click="playVideo" v-show="!videoStarted">
        <img src="https://summit-img.geekpark.net/03-%E8%A7%86%E9%A2%91-%E6%92%AD%E6%94%BE%E6%8C%89%E9%92%AE.svg"
             alt="">
      </div>
      <video style="width:100vw" ref="video" poster="https://summit-img.geekpark.net/video-bg.jpg" controlslist="nodownload noremoteplayback"
             :controls="videoStarted" >
        <source type="video/mp4" src="https://summit-img.geekpark.net/video/%E5%A4%A7%E4%BC%9A%E8%8A%B1%E7%B5%AE.MP4">
      </video>
    </div>
    <div class="footer">
      <img src="https://summit-img.geekpark.net/mobile/video-logo.svg" style="width: 18vw">
      <img src="https://summit-img.geekpark.net/mobile/video-innovation.svg" style="width: 42vw">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Video',
  data () {
    return {
      videoStarted: false,
      isPlaying: false
    }
  },
  mounted () {
    const video = this.$refs.video
    setInterval(() => {
      if (!(video.paused || video.ended || video.seeking)) {
        this.isPlaying = true
      } else {
        this.isPlaying = false
      }
    }, 200)
  },
  methods: {
    playVideo () {
      this.$refs.video.play()
      this.videoStarted = true
      this.isPlaying = true
    }
  }
}
</script>

<style scoped lang="less">
  .video {
    margin-top: 20vw;
    transition: background-color .5s;
  }

  .header {
    padding: 8vw 0;
  }

  .video-container {
    position: relative;

    .cover {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 10;

      img {
        width: 13vw;
        height: 13vw;
      }
    }
  }

  .footer {
    display: flex;
    justify-content: space-between;
    height: 30vw;
    padding: 0 6vw;
  }
</style>
